import { unsafeCSS } from "lit";

import base from "@/elements/assets/css/base.css?inline";

export const baseStyles = unsafeCSS(base);
